import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MentionModule } from 'angular-mentions';
import { HasPermissionsDirective } from 'src/app/shared/has-permissions.directive';
import { SharedModule } from 'src/app/shared/shared.module';
import { UiModule } from 'src/app/ui/ui.module';
import { WorkflowsPageComponent } from './components/workflows-page/workflows-page.component';
import { WorkflowsNewRulePageComponent } from './components/workflows-new-rule-page/workflows-new-rule-page.component';
import { WorkflowBuilderStepComponent } from './components/workflow-builder-step/workflow-builder-step.component';
import { WorkflowTriggerSelectComponent } from './components/workflow-trigger-select/workflow-trigger-select.component';
import { WorkflowConditionRowComponent } from './components/workflow-condition-row/workflow-condition-row.component';
import { WorkflowActionRowComponent } from './components/workflow-action-row/workflow-action-row.component';
import { WorkflowOrderModificationsComponent } from './components/workflow-order-modifications/workflow-order-modifications.component';

@NgModule({
  declarations: [
    WorkflowsPageComponent,
    WorkflowsNewRulePageComponent,
    WorkflowBuilderStepComponent,
    WorkflowTriggerSelectComponent,
    WorkflowConditionRowComponent,
    WorkflowActionRowComponent,
    WorkflowOrderModificationsComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    UiModule,
    HasPermissionsDirective,
    MentionModule,
    MatChipsModule,
    MatIconModule,
    MatProgressSpinnerModule,
  ],
})
export class WorkflowsModule {}
